import { useEffect, useMemo } from 'react';
import { isWhiteColor } from '../../Utils/helper';
import { cardServedEvent } from '../../Utils/StoreHomePageUtils';
import DoubleHorizontalScroll from '../HelperComponents/DoubleHorizontalScroll';
import {
  getShuffledData,
  newExperimentProducts,
  updateVariantType,
} from '../StoreCategoryPage/DiaperNewVersionMain/constant';
import { BannerTitle } from './BannersGrid/styled';
import { BrowseSection } from './BrowseAllProducts/styled';
import ProductCard from './ProductCard';
import { RelativeDiv } from './Testimonials/styled';
import { SkeletonBox } from '../Product/Skeleton/styled';

function TwoColumnGrid(props) {
  const {
    products,
    setChangeCartCount,
    showPrice,
    setOfferCartData,
    offerCartData,
    hideStickyStrip,
    showAnimation,
    userType,
    showVerticalGrid,
    headingText,
    isForNewCdPage,
  } = props;
  // let data = offerCartData?.productList || products?.items;
  let newData = [...products?.items, ...newExperimentProducts];

  useEffect(() => {
    cardServedEvent(products);
    // removeNonOfferItems(offerCartData);
  }, []);

  const totalData = useMemo(
    () => getShuffledData(newData, products?.items),
    [],
  );

  const actualData = offerCartData?.productList
    ? offerCartData?.productList
    : totalData;

  updateVariantType(offerCartData);
  return (
    <div>
      <BrowseSection
        className={showAnimation ? 'shakeanimation' : ''}
        sectionBgColorEnd={products?.sectionBgColorEnd}
        sectionBgColorStart={products?.sectionBgColorStart}
        padding={
          !isWhiteColor(
            products?.sectionBgColorStart,
            products?.sectionBgColorEnd,
          )
        }
        id="twoGrid"
        isForNewCdPage={isForNewCdPage}
      >
        {products?.heading ? (
          <BannerTitle categoryPage isForNewCdPage={isForNewCdPage}>
            {headingText === 'loading' ? (
              <SkeletonBox
                height={'32px'}
                width={'280px'}
                desktopHeight={'29px'}
                desktopWidth={'450px'}
                flex={true}
              />
            ) : (
              <h2>{headingText || products?.heading} </h2>
            )}
          </BannerTitle>
        ) : null}
        {isForNewCdPage && (
          <h5
            style={{
              textAlign: 'center',
              color: 'rgba(0,0,0,0.54)',
              paddingBottom: '20px',
              fontWeight: '300',
            }}
          >
            (with Extra Absorbent Pad & Booster Pad)
          </h5>
        )}

        <RelativeDiv>
          <DoubleHorizontalScroll
            firstElementId={`0first`}
            lastElementId={`${actualData?.length - 1}last`}
            scrolledWidth={300}
            doubleCarousel={true}
            showVerticalGrid={showVerticalGrid}
          >
            {actualData?.map((element, index) => {
              if (element.isBuyProduct) {
                return (
                  <ProductCard
                    maxWidth={'20%'}
                    card={element}
                    setChangeCartCount={setChangeCartCount}
                    sectionName={element?.name}
                    sectionId={products?.itemId}
                    showPrice={showPrice}
                    browse={true}
                    key={index}
                    index={index}
                    length={actualData?.length}
                    shrink="0"
                    showRating={false}
                    DoubleGrid={true}
                    setOfferCartData={setOfferCartData}
                    offerCartData={offerCartData}
                    hideStickyStrip={hideStickyStrip}
                    productList={actualData}
                    userType={userType}
                    clothDiaper={true}
                    showVerticalGrid={showVerticalGrid}
                    isForNewCdPage={isForNewCdPage}
                  />
                );
              }
            })}
          </DoubleHorizontalScroll>
        </RelativeDiv>
      </BrowseSection>
    </div>
  );
}

export default TwoColumnGrid;
